function initResourcesSliders() {
  var sliders = document.querySelectorAll('.resources-slider');
  if (!sliders.length) {
    return;
  }

  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 575.98px)') : null;

  function getPerPage() {
    return mobileQuery && mobileQuery.matches ? 1 : 3;
  }

  sliders.forEach(function(slider) {
    var track = slider.querySelector('.resources-slider__track');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.resources-slider__slide')) : [];
    var prevBtn = slider.querySelector('.resources-slider__arrow--prev');
    var nextBtn = slider.querySelector('.resources-slider__arrow--next');
    if (!track || !slides.length || !prevBtn || !nextBtn) {
      return;
    }

    var index = 0;

    function maxIndex() {
      return Math.max(0, slides.length - getPerPage());
    }

    function update() {
      var max = maxIndex();
      if (index > max) { index = max; }
      if (index < 0) { index = 0; }

      var slideRect = slides[0].getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      var offset = index * (slideRect.width + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';

      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= max;

      // Off-screen slides should not receive focus or be reachable via Tab.
      var perPage = getPerPage();
      slides.forEach(function(slide, i) {
        var isVisible = i >= index && i < index + perPage;
        if (isVisible) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    }

    prevBtn.addEventListener('click', function() {
      index = Math.max(0, index - getPerPage());
      update();
    });

    nextBtn.addEventListener('click', function() {
      index = Math.min(maxIndex(), index + getPerPage());
      update();
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 100);
    });

    update();
  });
}

export default initResourcesSliders;
